import { Component, forwardRef } from "@angular/core";
import type { ControlValueAccessor } from "@angular/forms";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: 'app-colour-selection-input',
    templateUrl: './colour-selection-input.component.html',
    styleUrls: ['./colour-selection-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AppColourSelectionInputComponent),
            multi: true
        }
    ]
}) export class AppColourSelectionInputComponent implements ControlValueAccessor {
    private readonly _colours: string[] = [
        'grey',
        'secondary',
        'info',
        'primary',
        'success',
        'warning',
        'error',
    ];

    protected readonly colours: {
        variants: string[];
        border: string;
        textColours: string[];
    }[] = this._colours.map(c => ({
        border: `${c}-normal`,
        variants: [`${c}-light`, `${c}-light-active`, `${c}-normal`, `${c}-dark`, `${c}-dark-active`],
        textColours: [`${c}-dark-active`, `${c}-dark-active`, `${c}-light`, `${c}-light`, `${c}-light`],
    }));

    public value?: string;

    public _onChange: (value: string) => any;
    public _onTouched: () => any;

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    writeValue(val: string): void {
        this.value = val;
    }

    setValue(val: string) {
        this.value = val;
        this._onChange(val);
    }

}
